// Show/hide toggle for password fields rendered by
// SACloudWeb.Helpers.FormHelpers.password_input_with_toggle/3.
//
// Delegated from the document so it works on both dead views and LiveViews, and
// keeps working when LiveView patches a form back into the DOM.

function toggle(button) {
    const wrapper = button.closest(".password-input");
    const input = wrapper && wrapper.querySelector("input");

    if (!input) return;

    const reveal = input.type === "password";
    const label = reveal ? button.dataset.hideLabel : button.dataset.showLabel;

    input.type = reveal ? "text" : "password";
    wrapper.classList.toggle("is-visible", reveal);

    // Read by the shared [data-tooltip] handler the next time it is shown.
    button.setAttribute("aria-label", label);
    button.dataset.tooltip = label;
}

document.addEventListener("click", event => {
    const button = event.target.closest(".password-toggle");

    if (button) {
        event.preventDefault();
        toggle(button);
    }
});
